import { createSelector } from '@ngrx/store';
import { getDragonflySharedState } from '../../reducers';

export const getLiteralsState = createSelector(getDragonflySharedState, (state) => state.literals);

export const getStoreName = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.storename']);

export const getStoreCode = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.storecode']);

export const getShowInactive = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.showinactive'],
);

export const getCountryCode = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.countrycode']);

export const getStoreDescription = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.storedescription'],
);

export const getIsActive = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.isactive']);

export const getIsDeactivated = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.isdeactivated'],
);

export const getEdit = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.edit']);

export const getActivate = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.activate']);

export const getDeactivate = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.deactivate']);

export const getCreateNewStore = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.createnewstore'],
);

export const getEditStore = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.editstore']);

export const getStorecodePattern = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.validation.store.storecode.pattern'],
);

export const getLanguages = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.languages']);

export const getStoreGroups = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.storegroups']);

export const getNoStoreGroups = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.nostoregroups'],
);

export const getPosNumber = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.posnumber']);

export const getPosVatNumber = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.posvatnumber'],
);

export const getPosMultiplier = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.posmultiplier'],
);

export const getNoPos = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.nopos']);

export const getDeleteAll = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.deleteall']);

export const getAttributesType = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.customer.details.attributes.type'],
);

export const getAttributesCode = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.customer.details.attributes.code'],
);

export const getAttributesValue = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.customer.details.attributes.value'],
);

export const getUpLimit = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.customer.details.attributes.number.uplimitval'],
);

export const getDownLimit = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.customer.details.attributes.number.downlimitval'],
);

export const getNoAttributes = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.noattributes'],
);

export const getClubs = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.clubs']);

export const getNoClubs = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.noclubs']);

export const getBrands = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.brands']);

export const getNoBrands = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.nobrands']);

export const getCouponsets = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.couponsets']);

export const getNoCouponsets = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.nocouponsets'],
);

export const getUsers = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.users']);

export const getNoUsers = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.nousers']);

export const getAddressDetails = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.addressdetails'],
);

export const getAddressLine = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.addressline']);

export const getTown = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.town']);

export const getPostcode = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.postcode']);

export const getCountry = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.country']);

export const getRegion = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.region']);

export const getCoordinates = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.coordinates']);

export const getDeactivateStore = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.youareabouttodeactivatestore'],
);

export const getAddBrands = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.additemsmodal.addbrands'],
);

export const getAddClubs = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.additemsmodal.addclubs'],
);

export const getAddCouponsets = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.additemsmodal.addcouponsets'],
);

export const getAddStoreGroups = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.additemsmodal.addstoregroups'],
);

export const getAddUsers = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.additemsmodal.addusers'],
);

export const getSelectNone = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.additemsmodal.selectnone'],
);

export const getSelectAll = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.additemsmodal.selectall'],
);

export const getNone = createSelector(getLiteralsState, ({ literals }) => literals['liquid.store.additemsmodal.none']);

export const getSelectedBrands = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.selectedbrands'],
);

export const getSelectedClubs = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.selectedclubs'],
);

export const getSelectedCouponsets = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.selectedcouponsets'],
);

export const getSelectedUsers = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.selectedusers'],
);

export const getStoreUpdateSuccess = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.update.success'],
);

export const getStoreCreateSuccess = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.create.success'],
);

export const getSearchByUsername = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.additemsmodal.searchby.users.username'],
);

export const getSearchByCouponsetCode = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.additemsmodal.searchby.couponsets.code'],
);

export const getSearchByCode = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.store.additemsmodal.couponsets.code'],
);
